import CookiesComponent from "./Cookies";
export default CookiesComponent;
